import { MenuProps } from 'components/Menu/Types'
import { observer } from 'mobx-react-lite'
import { useAlmanacEditorState } from 'stores/EditorState'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { computed } from 'mobx'
import { HighlightColorPicker } from 'common/Prose/components/HighlightColorPicker/HighlightColorPicker'
import Styles from './ColorPicker.module.scss'

export const HighlightColorPickerSubMenu = observer(({ onAction }: Pick<MenuProps<any>, 'menuType' | 'onAction'>) => {
  const editorState = useAlmanacEditorState()
  const view = useEditorView()

  const activeHighlightColors =
    computed(() => editorState?.highlightColors && Array.from(editorState.highlightColors)).get() || []

  return (
    <span className={Styles.root}>
      <HighlightColorPicker view={view} activeColors={activeHighlightColors} callback={() => onAction?.('')} />
    </span>
  )
})
